import "./lib/polyfills/Object.getPrototypeOf";
import "./lib/polyfills/Array.includes";
import "./lib/polyfills/Object.entries";
import "./lib/polyfills/String.includes";

import "./lib/global/FormData";

import "./lib/extensions/inputmask.extensions";
import "./lib/extensions/inputmask.date.extensions";
import "./lib/extensions/inputmask.numeric.extensions";
import "./lib/inputmaskElement";
import Inputmask from "./lib/inputmask";

export default Inputmask;
